export const createURLParams = params => {
  const filteredParams = params.join("&");
  const hasParams = params && params.length && params.some(param => param);

  return hasParams ? `?${filteredParams}` : "";
};
